export const TRANSPORT_BODYTYPE_ADDITIONALS = {
    SEMITRAILER: "1",
    TRUCK: "2",
    COUPLING: "3",
};

export const MODE_TRANSPORT = {
    exchange: "exchange",
    transport: "transport",
};
